import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ColumnWithLocalization } from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';
import { ApiClientConfig } from '../api-client-config';
import { ListEmailResponse } from 'it/primatoo/openapi/api/org/schemas/email/ListEmailResponse';
import { Email } from 'it/primatoo/openapi/api/org/schemas/email/listemailresponse/Email';
import { map } from 'rxjs/operators';
import { ListUserColumnsResponse } from 'it/primatoo/openapi/api/org/schemas/common/ListUserColumnsResponse';
import { UpsertUserColumnRequest } from 'it/primatoo/openapi/api/org/schemas/common/UpsertUserColumnRequest';

@Injectable({
  providedIn: 'root',
})
export class EmailsService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    this.endpoint = this.config.endPoint + '/api/org/v2/emails/';
  }

  public getEmailHistory(): Observable<Email[]> {
    const url = this.endpoint;
    return this.httpClient
      .get<ListEmailResponse>(url)
      .pipe(map((response) => response.emails ?? []));
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns/`;
    return this.httpClient
      .get<ListUserColumnsResponse>(url)
      .pipe(map((c) => c.columns));
  }

  public updateUserColumns(
    columnsConfigurationUpsertRequest: UpsertUserColumnRequest
  ): Observable<void> {
    const url = this.endpoint + 'user-columns/';
    return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  }

  public sendSupportRequest(
    subject: string,
    content: string
  ): Observable<void> {
    const url = this.endpoint + 'send-support-request';
    return this.httpClient.post<void>(url, { subject, content });
  }

  getEndPoint(): string {
    return this.endpoint;
  }
}
